<template>
    <div class="card-body">
        <v-text-field
            :label="$t('message.campaigns.message.campaignName')"
            :name="$t('message.campaigns.message.campaignName')"
            v-model="val.nome"
            v-validate="'required'"
            :readonly="readonly"
            :error-messages="
                errors.collect($t('message.campaigns.message.campaignName'))
            "
            @input="$emit('input', val)"
        ></v-text-field>

        <v-text-field
            :label="$t('message.campaigns.message.postAuthPage')"
            :name="$t('message.campaigns.message.postAuthPage')"
            v-model="val.paginaPosAutenticacao"            
            :readonly="readonly"           
            @input="$emit('input', val)"
        ></v-text-field>

        <div class="dates">
            <app-box-wrapper
                :data-label="$t('message.generics.message.startDate')"
                data-icon="mdi-calendar-range"
            >
                <app-date-picker
                    v-model="val.dataInicio"
                    :readonly="readonly"
                    menu-width="auto"
                    @input="$emit('input', val)"
                ></app-date-picker>
            </app-box-wrapper>

            <app-box-wrapper
                :data-label="$t('message.generics.message.endDate')"
                data-icon="mdi-calendar-range"
            >
                <app-date-picker
                    v-model="val.dataFim"
                    :readonly="readonly"
                    menu-width="auto"
                    @input="$emit('input', val)"
                ></app-date-picker>
            </app-box-wrapper>
        </div>

        <div class="interval">
            <h4 class="text-muted">
                {{ $t("message.campaigns.message.airingInterval") }}
            </h4>

            <div class="period period_inputs">
                <div class="period-column" v-on:click="changeDaysInterval()">
                    <v-checkbox
                        v-model="val.isTodosDias"
                        :readonly="readonly"
                        :label="$t('message.campaigns.message.everyDay')"
                    ></v-checkbox>
                </div>

                <div class="period-column" v-on:click="changeHourInterval()">
                    <v-checkbox
                        v-model="val.isDiaInteiro"
                        :label="$t('message.campaigns.message.allDay')"
                    ></v-checkbox>
                </div>
            </div>

            <div class="period">
                <div class="period-column">
                    <div class="buttons" v-if="!val.isTodosDias">
                        <v-btn-toggle
                            v-model="val.diasSemana"
                            multiple
                            :readonly="readonly"
                        >
                            <v-btn
                                flat
                                v-for="day in weekdays"
                                :key="day"
                                :style="stylebutton"
                            >
                                {{ day }}
                            </v-btn>
                        </v-btn-toggle>
                    </div>
                </div>

                <div class="period-column">
                    <app-box-wrapper
                        data-icon="mdi-clock"
                        v-if="!val.isDiaInteiro"
                    >
                        <app-hour-picker
                            v-model="val.horaInicio"
                            :readonly="readonly"
                            class="hour"
                            datalabel="Hora início"
                            @input="$emit('input', val)"
                        ></app-hour-picker>

                        <span>-</span>
                        <app-hour-picker
                            v-model="val.horaFim"
                            datalabel="Hora fim"
                            class="hour"
                            :readonly="readonly"
                            @input="$emit('input', val)"
                        ></app-hour-picker>
                    </app-box-wrapper>
                </div>
            </div>
        </div>

        <div class="segment">
            <h4 class="text-muted">
                {{ $t("message.campaigns.message.segmentation") }}
            </h4>

            <app-tab-selector
                v-model="val.filtroSexo"
                :readonly="readonly"
                :data-tabs="tabs"
            ></app-tab-selector>

            <app-range-slider
                :value="[val.filtroIdadeInicial, val.filtroIdadeFinal]"
                :readonly="readonly"
                :data-label="$t('message.campaigns.message.yearsOld')"
                @input="sliderInput"
            ></app-range-slider>

            <AdvertisingFormAdvancedConfig
                v-model="advancedConfigs"
                @input="setAdvacedConfig"
            />
        </div>
    </div>
</template>

<script>
import AppBoxWrapper from "@components/BoxWrapper";
import AppDatePicker from "@components/DatePicker";
import AppTabSelector from "@components/TabSelector";
import vModel from "@mixins/v-model";
import AppRangeSlider from "@components/RangeSlider";
import EventBus from "@packages/event-bus";
import AppHourPicker from "@components/HourPicker";
import AdvertisingFormAdvancedConfig from "@views/advertising/components/advertising-modal/components/advanced-config/AdvertisingFormAdvancedConfig";

export default {
    components: {
        AppBoxWrapper,
        AppDatePicker,
        AppTabSelector,
        AppRangeSlider,
        AppHourPicker,
        AdvertisingFormAdvancedConfig,
    },

    data() {
        return {
            advancedConfigs: this.value
                ? {
                      anuncianteId: this.value.anuncianteId,
                      integrationTrigger: this.value.integrationTrigger,
                      isBirthdate: this.value.isBirthdate,
                      allCaptiveLoginTypeSelected:
                          this.value.allCaptiveLoginTypeSelected,
                      allSsidSelected: this.value.allSsidSelected,
                      captiveLoginTypeFilter: this.value.captiveLoginTypeFilter,
                      ssidFilter: this.value.ssidFilter || [],
                  }
                : {
                      anuncianteId: undefined,
                      integrationTrigger: undefined,
                      isBirthdate: false,
                      allSsidSelected: true,
                      allCaptiveLoginTypeSelected: true,
                      captiveLoginTypeFilter: [],
                      ssidFilter: [],
                  },
        };
    },

    props: {
        readonly: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        stylebutton() {
            return {
                width: 100 / this.weekdays.length + "%",
                border: "none",
            };
        },
        tabs() {
            return [
                {
                    value: null,
                    label: this.$t("message.campaigns.message.everyone"),
                },
                {
                    value: "MASCULINO",
                    label: this.$t("message.campaigns.message.men"),
                },
                {
                    value: "FEMININO",
                    label: this.$t("message.campaigns.message.women"),
                },
                {
                    value: "NAO_DECLARADO",
                    label: this.$t("message.generics.message.notInformed"),
                },
            ];
        },
        weekdays() {
            return [
                this.$t("message.campaigns.message.sunday"),
                this.$t("message.campaigns.message.monday"),
                this.$t("message.campaigns.message.tuesday"),
                this.$t("message.campaigns.message.wednesday"),
                this.$t("message.campaigns.message.thursday"),
                this.$t("message.campaigns.message.friday"),
                this.$t("message.campaigns.message.saturday"),
            ];
        },
    },

    methods: {
        setAdvacedConfig() {
            const newVal = {
                ...this.val,
                ...this.advancedConfigs,
            };

            this.$emit("input", newVal);
        },
        changeDaysInterval() {
            if (!this.val.isTodosDias && !this.val.diasSemana) {
                this.val.diasSemana = [0, 1, 2, 3, 4, 5, 6];
            }
        },
        changeHourInterval() {
            if (!this.val.isDiaInteiro && !this.val.horaInicio) {
                this.val.horaInicio = "0000";
                this.val.horaFim = "2359";
            }
        },
        sliderInput(evt) {
            this.val.filtroIdadeInicial = evt[0];
            this.val.filtroIdadeFinal = evt[1];
            this.$emit("input", this.val);
        },

        dropdownInput(evt) {
            this.val.anuncianteId = evt.id;
            this.$emit("input", this.val);
        },

        async validate() {
            await this.$validator.validateAll();

            if (this.$validator.errors.items.length !== 0)
                return this.$emit("to-general-tab");

            this.$emit("valid");
        },

        reset() {
            this.advancedConfigs = this.value
                ? {
                      anuncianteId: this.value.anuncianteId,
                      integrationTrigger: this.value.integrationTrigger,
                      isBirthdate: this.value.isBirthdate,
                      allCaptiveLoginTypeSelected:
                          this.value.allCaptiveLoginTypeSelected,
                      allSsidSelected: this.value.allSsidSelected,
                      captiveLoginTypeFilter: this.value.captiveLoginTypeFilter,
                      ssidFilter: this.value.ssidFilter || [],
                  }
                : {
                      anuncianteId: undefined,
                      integrationTrigger: undefined,
                      isBirthdate: false,
                      allCaptiveLoginTypeSelected: true,
                      allSsidSelected: true,
                      captiveLoginTypeFilter: [],
                      ssidFilter: [],
                  };
            this.$validator.reset();
        },
    },

    mixins: [vModel],

    mounted() {
        EventBus.$on("RESET_ADVERTISING_MODAL", this.reset);
    },

    beforeDestroy() {
        EventBus.$off("RESET_ADVERTISING_MODAL", this.reset);
    },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.card-body {
    padding: 18px 50px 10px;

    .v-input {
        margin: 12px 0 10px 0;
    }

    .dates {
        display: flex;
        margin-bottom: 32px;

        .date {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 1 0 auto;

            .datepicker-wrapper {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 175px;
                height: 55px;
                padding: 0 15px;
                border: $border-1;
                border-radius: 4px;
                font-weight: bold;
                color: $grey-4;

                .mdi {
                    font-size: 24px;
                }

                input {
                    color: $grey-4;
                }
            }
        }
    }

    .segment {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;

        & > *:not(:first-child) {
            margin-top: 10px;
        }

        .birthday-checkbox {
            justify-content: center;
            width: 100% !important;
        }

        .advanced-config {
            width: 100%;
        }
    }

    .interval {
        margin-bottom: 32px;
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1 0 auto;

        .v-input--checkbox {
            font-weight: 500;
            height: 20px;
            width: 140px !important;
            margin-left: auto !important;
            margin-right: auto !important;
        }
        .box {
            margin-top: 5px;
        }
    }
    .interval .period {
        width: 100%;
    }

    .period {
        display: flex;

        .period-column {
            flex-shrink: 0;
            flex-basis: 50%;
        }

        &.period_inputs {
            margin-bottom: 10px;
        }
    }

    .box .box-wrapper {
        border-radius: 30px !important;
    }

    .buttons {
        border: none !important;
    }

    .v-btn-toggle {
        box-shadow: unset;
    }
}
.v-item-group {
    width: 260px;
}
.v-btn--active:before,
.v-btn:focus:before,
.v-btn:hover:before {
    background-color: unset;
}

.v-btn--active {
    color: $primary !important;
}

.period-column {
    display: block;
}

.v-input--checkbox {
    width: 150px !important;
    margin-left: auto !important;
    margin-right: auto !important;
}
</style>
